{
    "vehicle": {
        "type": "CAR",
        "language": "es",
        "brand": "Volvo",
        "model": "XC90",
        "version": "v2",
        "price": 61878.19,
        "vin": "",
        "modelYear": 0,
        "mileage": 0,
        "annualMileage": 10000,
        "plateNumber": "0000BCD",
        "firstRegistrationDate": ""
    },
    "financialData": {
        "installmentMonthlyGrossAmount": 956.93,
        "installmentTotalGrossAmount": 73474.61,
        "installmentFirstGrossAmount": 1015.81,
        "installmentLastGrossAmount": 956.86,
        "currencyCode": "EUR",
        "vat": 21.0,
        "aprcRate": 9.66,
        "nominalRate": 7.95,
        "totalAmount": 47249.95,
        "totalInterestGrossAmount": 10224.66,
        "financialProduct": {
            "id": "MCM",
            "name": "CREDIT_CLASSIC"
        },
        "duration": 36,
        "downPaymentGrossAmount": 16000.0,
        "annualMileages": 25000,
        "formalizationFee": {
            "type": "FINANCED",
            "amount": 1371.76,
            "percentage": 2.99
        },
        "totalCreditCost": 11596.42,
        "totalAmountDue": 57474.61,
        "paymentProtectionInsurance": false,
        "secureCode" : "7045A"
    }
}
